import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "store/store";
import type { AuthState } from "types/authTypes";

const initialState: AuthState = {
  accessToken: "",
  refreshToken: "",
};

const loadAuthState = (): AuthState => {
  const accessToken = localStorage.getItem("accessToken");
  const refreshToken = localStorage.getItem("refreshToken");
  return accessToken && refreshToken
    ? {
        accessToken,
        refreshToken,
      }
    : initialState;
};

const authSlice = createSlice({
  name: "auth",
  initialState: loadAuthState(),
  reducers: {
    setAuth: (state, action: PayloadAction<AuthState>) => {
      state.accessToken = action.payload.accessToken;
      state.refreshToken = action.payload.refreshToken;
    },
    setAuthTokens: (state, action: PayloadAction<AuthState>) => {
      state.accessToken = action.payload.accessToken;
      state.refreshToken = action.payload.refreshToken;
    },
    resetAuth: (state) => {
      state.accessToken = "";
      state.refreshToken = "";
    },
  },
});

export const { setAuth, resetAuth, setAuthTokens } = authSlice.actions;

export const selectAuth = (state: RootState) => state.auth;

export default authSlice.reducer;
